import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="product-card-preview"
export default class extends Controller {
  static get targets() {
    return ['select', 'output']
  }

  static get values() {
    return { price: String }
  }

  connect() {
    this.update()
  }

  update() {
    const lines = []
    if (this.priceValue && this.priceValue.trim() !== '') lines.push(this.priceValue)
    if (this.hasSelectTarget) {
      const select = this.selectTarget
      const order = select.tomselect ? select.tomselect.items : [...select.selectedOptions].map((o) => o.value)
      order.forEach((value) => {
        const option = select.querySelector(`option[value="${CSS.escape(value)}"]`)
        const preview = option?.dataset.preview
        if (preview && preview.trim() !== '') lines.push(preview)
      })
    }
    this.outputTarget.textContent = lines.join('\n')
  }
}
